import { PuzzleAttempt } from "./puzzle";

const storage_key = "saved_game"

export function saveCurrentGame(attempt: PuzzleAttempt) {
    localStorage.setItem(storage_key, JSON.stringify({
        puzzle: attempt.puzzle,
        slants: attempt.slants
    }));
}

export function loadGame(): PuzzleAttempt {
    try {
        let gamestr = localStorage.getItem(storage_key)
        if (!gamestr) return null;
        let game = JSON.parse(gamestr);
        if (!game) return null;
        return new PuzzleAttempt(game.puzzle, game);
    } catch {
        return null;
    }
}

const music_key = "music_pref"

export function prefersMusic(): boolean {
    let currentPref = localStorage.getItem(music_key);
    return currentPref == "true" || currentPref === null;
}

export function setPrefersMusic(val: boolean) {
    localStorage.setItem(music_key, val ? "true" : "false");
}

const sound_key = "sound_pref"

export function prefersSound(): boolean {
    let currentPref = localStorage.getItem(sound_key);
    return currentPref == "true" || currentPref === null;
}

export function setPrefersSound(val: boolean) {
    localStorage.setItem(sound_key, val ? "true" : "false");
}

const theme_key = "theme_pref"

export function preferredTheme() {
    let currentPref = localStorage.getItem(theme_key);
    return currentPref ?? "dark"
}

export function setPreferredTheme(theme: string) {
    localStorage.setItem(theme_key, theme);
}